import GenerateSegmentsModal from './GenerateSegmentsModal';
export default GenerateSegmentsModal;
